import Metadata from '../../requests/apa/Metadata';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import PlayerHelper from '../../AAFPlayer/helpers/PlayerHelper';
import * as constant from '../../AAFPlayer/constants';

let enabledSpinner = false;
let disabledFor = [];

const init = function() {
  try {
    const meta = Metadata.get(
      'enabled_spinner',
      '{"default":{"enable":false}, "colombia":{"enable":true,"disabledFor":["vod", "npvr", "catchup", "live"]}}'
    );
    const objectMeta = JSON.parse(meta);
    var _region = DeviceStorage.getItem('region');
    const value = objectMeta[_region] ? objectMeta[_region] : objectMeta['default'];
    if (value && typeof value == 'object') {
      enabledSpinner = value.enable;
      if (value.disabledFor && Array.isArray(value.disabledFor)) {
        disabledFor = value.disabledFor;
      }
    }
  } catch (e) {}
};

const disableSpinnerByContent = function(nextOptions) {
  if (enabledSpinner) {
    let contentType = PlayerHelper.getContentType(nextOptions);
    let name_content = getTypeContent(contentType);
    const findValueFromMeta = disabledFor.find(el => el == name_content);
    if (findValueFromMeta) {
      return false;
    } else {
      return true;
    }
  } else {
    // SE DEJA ANTERIOR CONFIGURACION
    if (nextOptions.islive && !nextOptions.ispip) {
      return true;
    } else {
      return false;
    }
  }
};

const getTypeContent = function(type) {
  let result = '';
  switch (type) {
    case constant.AAF_CONTENT_IS_VOD:
      result = 'vod';
      break;
    case constant.AAF_CONTENT_IS_NPVR:
      result = 'npvr';
      break;
    case constant.AAF_CONTENT_IS_CATCHUP:
      result = 'catchup';
      break;
    case constant.AAF_CONTENT_IS_STARTOVER:
      result = 'startover';
      break;
    case constant.AAF_CONTENT_IS_TIMESHIFT:
      result = 'timeshift';
      break;
    case constant.AAF_CONTENT_IS_TV:
      result = 'live';
      break;
    case constant.AAF_CONTENT_IS_AUDIO:
      result = 'audio';
      break;
    case constant.AAF_CONTENT_IS_RADIO:
      result = 'radio';
      break;
    default:
      result = null;
      break;
  }
  return result;
};

const EnableSpinner = {
  init,
  disableSpinnerByContent
};

export default EnableSpinner;



// WEBPACK FOOTER //
// ./src/AAF/Spinner/EnableSpinner.js